import { render, staticRenderFns } from "./token-box2.vue?vue&type=template&id=20e4afec&scoped=true&"
import script from "./token-box2.vue?vue&type=script&lang=js&"
export * from "./token-box2.vue?vue&type=script&lang=js&"
import style0 from "./token-box2.vue?vue&type=style&index=0&id=20e4afec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e4afec",
  null
  
)

export default component.exports